import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminServicePage from './pages/AdminServicePage';
import AdminInternshipPage from './pages/AdminInternshipPage';
import AdminApplicationPage from './pages/AdminApplicationPage';
import AdminPageEditor from './pages/AdminPageEditor';
import ApplyPage from './pages/ApplyPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Single Page */}
        <Route path="/" element={<LandingPage />} />

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLoginPage />} />
        <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
        <Route path="/admin/services" element={<AdminServicePage />} />
        <Route path="/admin/internships" element={<AdminInternshipPage />} />
        <Route path="/admin/applications" element={<AdminApplicationPage />} />
        <Route path="/admin/pages" element={<AdminPageEditor />} />
        <Route path="/apply/:internshipId" element={<ApplyPage />} />
      </Routes>

      <ToastContainer position="top-center" />
    </Router>
  );
}

export default App;
